import { Action, createAction, handleActions } from 'redux-actions'

export interface ISelectCardState {
  [key: string]: boolean
}

export const SELECT_CARD = 'SelectCard'

const CHECK = `${SELECT_CARD}/CHECK`
const RESET = `${SELECT_CARD}/RESET`

export const SelectCardActions = {
  check: createAction(CHECK),
  reset: createAction(RESET),
}

const initialState = {}

export const reducer = {
  [CHECK]: (state: ISelectCardState, action: Action<string>) => ({
    ...state,
    [action.payload]: true,
  }),
  [RESET]: (state: ISelectCardState, action: Action<string>) => ({
    ...initialState,
  }),
}

export const selectCardReducer = handleActions(reducer, initialState)
